import Base from "../Base";
export default class RefonteTarifaire extends Base {
  init(id, main, locale) {
    console.log(":: RefonteTarifaire ::");

    window.addEventListener("scroll", () => {
      document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
    });

    const inputSearch = document.getElementById("myInputSearch");

    if (inputSearch) {
      inputSearch.onkeyup = (e) => {
        this.searchThroughList(e);
      };
    }

    const Buttons = document.querySelectorAll(".listMuni .single-muni");

    const ButtonsZoneMuni = document.querySelectorAll(".listMuni .single-link-zoneMuni");

    for (const buttonZoneMuni of ButtonsZoneMuni) {
      buttonZoneMuni.addEventListener("click", (e) => {
        this.switchZone(e);
      });
    }

    const BtnTer = document.getElementsByClassName("btnZoneTerritory");
    for (const btnZoneTer of BtnTer) {
      btnZoneTer.addEventListener("mouseover", (e) => {
        this.hoverBtnZone(e);
      });
      btnZoneTer.addEventListener("mouseout", (e) => {
        this.hoverOutBtnZone(e);
      });
      btnZoneTer.addEventListener("click", (e) => {
        this.closeListZone(e);
      });
    }

    const BtnZones = document.getElementsByClassName("mapZones");
    for (const btnZone of BtnZones) {
      btnZone.addEventListener("mouseover", (e) => {
        this.hoverBtnZone(e);
      });
      btnZone.addEventListener("mouseout", (e) => {
        this.hoverOutBtnZone(e);
      });
      btnZone.addEventListener("click", (e) => {
        this.openListZone(e);
      });
    }

    const Anchors = document.getElementsByClassName("single-anchor");
    for (const anchor of Anchors) {
      anchor.addEventListener("click", (e) => {
        this.scroll(e);
      });
    }

    const scrollTopBtn = document.getElementById("scrollToTop");
    if (scrollTopBtn) {
      scrollTopBtn.addEventListener("click", (e) => {
        this.scroll(e);
      });
    }

    const modalPop = document.querySelector(".modal-infos");
    const bgModalPop = document.querySelector(".bgModalInfos");
    const PopButtons = document.querySelectorAll(".link-knowMore");
    const contentPopup = document.querySelector(".contentPopup");
    for (const popButton of PopButtons) {
      popButton.addEventListener("click", (e) => {
        this.onButtonPopClick(e, modalPop, bgModalPop, contentPopup);
      });
    }

    const closeModalBtns = document.querySelectorAll(".closeModalBtn");

    if (closeModalBtns) {
      for (const closeModalBtn of closeModalBtns) {
        closeModalBtn.addEventListener("click", (e) => {
          this.closeModalPop(modalPop, bgModalPop, contentPopup);
        });
      }
    }

    bgModalPop.addEventListener("click", (e) => {
      this.closeModalPop(modalPop, bgModalPop, contentPopup);
    });

    this.detectParentFAQ();
  }

  onButtonPopClick(e, modalPop, bgModalPop, contentPopup) {
    const target = e.currentTarget.closest(".single-knowMore");

    modalPop.querySelector(".contentPopup").innerHTML = target.querySelector(".contentInPopup").innerHTML;

    this.showModalPop(modalPop, bgModalPop, contentPopup);
  }

  showModalPop(modalPop, bgModalPop, contentPopup) {
    console.log("allo");
    modalPop.style.display = "block";
    bgModalPop.style.display = "block";

    const scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
    const body = document.body;
    body.style.position = "fixed";
    body.style.top = `-${scrollY}`;
    body.style.width = "100%";
    body.style.overflow = "hidden";

    document.getElementsByTagName("html")[0].style.scrollBehavior = "auto";

    this.checkModalPopHeight(modalPop, contentPopup);
  }

  closeModalPop(modalPop, bgModalPop, contentPopup) {
    modalPop.style.display = "none";
    modalPop.querySelector(".contentPopup").innerHTML = "";
    bgModalPop.style.display = "none";

    const body = document.body;
    const scrollY = body.style.top;
    body.style.position = "";
    body.style.top = "";
    body.style.width = "initial";
    body.style.overflow = "initial";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);

    modalPop.style.height = "initial";
    contentPopup.classList.remove("showScroll");

    document.getElementsByTagName("html")[0].style.scrollBehavior = "smooth";
  }

  checkModalPopHeight(modalPop, contentPopup) {
    const headerPopup = document.querySelector(".headerPopup");
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    let marginPadding = 140;
    if (document.body.clientWidth < 992) {
      marginPadding = 80;
    }
    if (document.body.clientWidth < 768) {
      marginPadding = 85;

      if (isMobile) {
        marginPadding = 100;
      }
    }

    if (contentPopup.scrollHeight > modalPop.clientHeight - (headerPopup.clientHeight + marginPadding)) {
      modalPop.style.height = "100%";
      contentPopup.classList.add("showScroll");
    }
  }

  hoverBtnZone(e) {
    const et = e.currentTarget;
    const inactive = document.getElementsByClassName("inactive");

    const zoneA = document.getElementsByClassName("zoneA");
    const zoneB = document.getElementsByClassName("zoneB");
    const zoneC = document.getElementsByClassName("zoneC");
    const zoneD = document.getElementsByClassName("zoneD");
    const zoneA_letter = document.getElementsByClassName("zoneA_letter");
    const zoneB_letter = document.getElementsByClassName("zoneB_letter");
    const zoneC_letter = document.getElementsByClassName("zoneC_letter");
    const zoneD_letter = document.getElementsByClassName("zoneD_letter");

    if (et.classList.contains("btnZoneA")) {
      for (const b of zoneB) {
        b.classList.add("inactive");
      }

      for (const c of zoneC) {
        c.classList.add("inactive");
      }

      for (const d of zoneD) {
        d.classList.add("inactive");
      }

      for (const bl of zoneB_letter) {
        bl.classList.add("inactive");
      }

      for (const cl of zoneC_letter) {
        cl.classList.add("inactive");
      }

      for (const dl of zoneD_letter) {
        dl.classList.add("inactive");
      }
    }

    if (et.classList.contains("btnZoneB")) {
      for (const a of zoneA) {
        a.classList.add("inactive");
      }

      for (const c of zoneC) {
        c.classList.add("inactive");
      }

      for (const d of zoneD) {
        d.classList.add("inactive");
      }

      for (const al of zoneA_letter) {
        al.classList.add("inactive");
      }

      for (const cl of zoneC_letter) {
        cl.classList.add("inactive");
      }

      for (const dl of zoneD_letter) {
        dl.classList.add("inactive");
      }
    }

    if (et.classList.contains("btnZoneC")) {
      for (const a of zoneA) {
        a.classList.add("inactive");
      }

      for (const b of zoneB) {
        b.classList.add("inactive");
      }

      for (const d of zoneD) {
        d.classList.add("inactive");
      }

      for (const al of zoneA_letter) {
        al.classList.add("inactive");
      }

      for (const bl of zoneB_letter) {
        bl.classList.add("inactive");
      }

      for (const dl of zoneD_letter) {
        dl.classList.add("inactive");
      }
    }

    if (et.classList.contains("btnZoneD")) {
      for (const a of zoneA) {
        a.classList.add("inactive");
      }

      for (const b of zoneB) {
        b.classList.add("inactive");
      }

      for (const c of zoneC) {
        c.classList.add("inactive");
      }

      for (const al of zoneA_letter) {
        al.classList.add("inactive");
      }

      for (const bl of zoneB_letter) {
        bl.classList.add("inactive");
      }

      for (const cl of zoneC_letter) {
        cl.classList.add("inactive");
      }
    }

    if (et.classList.contains("btnZoneTerritory")) {
      for (const a of zoneA) {
        a.classList.add("inactive");
      }

      for (const b of zoneB) {
        b.classList.add("inactive");
      }

      for (const c of zoneC) {
        c.classList.add("inactive");
      }

      for (const d of zoneD) {
        d.classList.add("inactive");
      }

      for (const al of zoneA_letter) {
        al.classList.add("inactive");
      }

      for (const bl of zoneB_letter) {
        bl.classList.add("inactive");
      }

      for (const cl of zoneC_letter) {
        cl.classList.add("inactive");
      }

      for (const dl of zoneD_letter) {
        dl.classList.add("inactive");
      }
    }
  }

  hoverOutBtnZone(e) {
    const et = e.currentTarget;
    const inactive = document.getElementsByClassName("inactive");

    const zoneA = document.getElementsByClassName("zoneA");
    const zoneB = document.getElementsByClassName("zoneB");
    const zoneC = document.getElementsByClassName("zoneC");
    const zoneD = document.getElementsByClassName("zoneD");
    const zoneA_letter = document.getElementsByClassName("zoneA_letter");
    const zoneB_letter = document.getElementsByClassName("zoneB_letter");
    const zoneC_letter = document.getElementsByClassName("zoneC_letter");
    const zoneD_letter = document.getElementsByClassName("zoneD_letter");

    for (const a of zoneA) {
      a.classList.remove("inactive");
    }

    for (const b of zoneB) {
      b.classList.remove("inactive");
    }

    for (const c of zoneC) {
      c.classList.remove("inactive");
    }

    for (const d of zoneD) {
      d.classList.remove("inactive");
    }

    for (const al of zoneA_letter) {
      al.classList.remove("inactive");
    }

    for (const bl of zoneB_letter) {
      bl.classList.remove("inactive");
    }

    for (const cl of zoneC_letter) {
      cl.classList.remove("inactive");
    }

    for (const dl of zoneD_letter) {
      dl.classList.remove("inactive");
    }
  }

  closeListZone(e) {
    const et = e.currentTarget;

    const allContent = document.querySelectorAll(".single-zone_info");

    for (const content of allContent) {
      if (content.getAttribute("data-zone-map") === et.getAttribute("data-zone-map")) {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    }
  }

  openListZone(e) {
    const et = e.currentTarget;

    const allContent = document.querySelectorAll(".single-zone_info");

    for (const content of allContent) {
      if (content.getAttribute("data-zone-map") === et.getAttribute("data-zone-map")) {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    }

    this.scrollToZone();
  }

  scrollToZone() {
    var target = document.getElementById("zonesMapInfos").getBoundingClientRect().top;

    const btnMapZones = document.getElementsByClassName("btnMapZones");
    const btnZonesScroll = document.getElementsByClassName("btnZones");

    for (const btnMapZone of btnMapZones) {
      btnMapZone.classList.add("disableCursor");
    }

    for (const btnZoneScroll of btnZonesScroll) {
      btnZoneScroll.classList.add("disableCursor");
    }

    this.animateScroll(target, () => {
      for (const btnMapZone of btnMapZones) {
        btnMapZone.classList.remove("disableCursor");
      }

      for (const btnZoneScroll of btnZonesScroll) {
        btnZoneScroll.classList.remove("disableCursor");
      }
    });
  }

  scroll(e) {


    e.preventDefault();
    var id = e.currentTarget.getAttribute("href").replace("#", "");
    var target = document.getElementById(id).getBoundingClientRect().top;
    this.animateScroll(target);
  }

  animateScroll(targetHeight, callback) {

    targetHeight =
      document.body.scrollHeight - window.innerHeight > targetHeight + scrollY
        ? targetHeight
        : document.body.scrollHeight - window.innerHeight;
    var initialPosition = window.scrollY;
    var SCROLL_DURATION = 30;
    var step_x = Math.PI / SCROLL_DURATION;
    var step_count = 0;
    function step() {
      if (step_count < SCROLL_DURATION) {
        requestAnimationFrame(step);
        step_count++;
        window.scrollTo(0, initialPosition + targetHeight * 0.25 * Math.pow(1 - Math.cos(step_x * step_count), 2));
      } else if (step_count == SCROLL_DURATION) {
        if (typeof callback == "function") {
          callback();
        }
      }
    }
    requestAnimationFrame(step);
  }

  switchZone(e) {
    const et = e.target;
    const actives = document.querySelectorAll(".single-link-zoneMuni.active");
    const searchMuni = document.querySelector(".searchMuni");
    const btnsSingleMuni = document.querySelectorAll(".btnSingleMuni");

    if (!searchMuni.classList.contains("openModal")) {
      searchMuni.classList.add("openModal");
    }

    for (const active of actives) {
      active.classList.remove("active");
    }

    et.classList.add("active");

    const allContent = document.querySelectorAll(".single-zone");

    for (const content of allContent) {
      if (content.getAttribute("data-zone") === et.getAttribute("data-zone")) {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    }

    for (const btnSingleMuni of btnsSingleMuni) {
      if (et.getAttribute("data-id")) {
        const hrefNoParam = btnSingleMuni.href.substr(0, btnSingleMuni.href.indexOf("?")) || btnSingleMuni.href;
        btnSingleMuni.href = `${hrefNoParam}?muni=${et.getAttribute("data-id")}`;
      }
    }
  }

  searchThroughList(e) {
    var search = e.currentTarget.value.toLowerCase();
    document.querySelectorAll(".containerMuni li").forEach((row) => {
      var text = row.innerText.toLowerCase();
      if (text.match(search)) {
        row.style.display = "block";
      } else {
        row.style.display = "none";
      }
    });
  }

  detectParentFAQ() {
    var collectionrefFAQ = document.querySelectorAll(".listTheme");
    collectionrefFAQ.forEach((group) => {
      var itemcollectionFAQ = group.getElementsByClassName("singleQuestion");
      var hidecounterFAQ = 0;
      for (var j = 0; j < itemcollectionFAQ.length; j++) {
        if (itemcollectionFAQ[j].style.display === "none") {
          hidecounterFAQ++;
        }
      }

      if (hidecounterFAQ === itemcollectionFAQ.length) {
        group.style.display = "none";
      } else {
        group.style.display = "block";
      }
    });
  }
}
